module.exports = {
  gndHierarchy: require('./gnd'),
}
